import { PetRarity } from '@gatto/shared'

export const getCurrentSkin = (rarity?: PetRarity): PetRarity => {
  return rarity || PetRarity.Normal
}
